import classNames from 'classnames';
import { ReactNode } from 'react';
import { FormattedDate } from 'react-intl';
import styled from 'styled-components';

import { Modal } from '@sorare/core/src/atoms/Modal';
import { Horizontal, Vertical } from '@sorare/core/src/atoms/layout/flex';
import { LabelL } from '@sorare/core/src/atoms/typography';
import { absCenter } from '@sorare/core/src/lib/style';
import { tabletAndAbove } from '@sorare/core/src/style/mediaQuery';

import blue from 'components/rivals/PromotionRelegationStory/assets/blue.jpg';
import orange from 'components/rivals/PromotionRelegationStory/assets/orange.jpg';
import pink from 'components/rivals/PromotionRelegationStory/assets/pink.jpg';

const Root = styled(Vertical).attrs({ gap: 2, center: true })`
  position: fixed;
  inset: 0;
  overflow: hidden;
  background-position: center;
  background-size: cover;
  background-repeat: no-repeat;
  background-color: var(--c-neutral-100);
  justify-content: space-between;
  padding: calc(6 * var(--unit)) 0;

  &.pink {
    background-image: url(${pink});
  }
  &.blue {
    background-image: url(${blue});
  }
  &.orange {
    background-image: url(${orange});
  }

  @media ${tabletAndAbove} {
    padding: calc(10 * var(--unit)) 0;
  }
`;

const DateWrapper = styled(Horizontal).attrs({ center: true })`
  background: var(--c-neutral-1000);
  color: var(--c-neutral-100);
  padding: var(--half-unit) var(--intermediate-unit);
  border-radius: var(--half-unit);
`;

const DivisionImage = styled.img`
  ${absCenter}
  object-fit: contain;
  width: calc(30 * var(--unit));
`;

type Props = {
  title: ReactNode;
  backgroundType: 'pink' | 'blue' | 'orange';
  badgeUrl: string;
  divisionTitle: string;
  ctas: ReactNode;
};
export const BaseLayout = ({
  title,
  backgroundType,
  badgeUrl,
  divisionTitle,
  ctas,
}: Props) => {
  const date = new Date();

  return (
    <Modal>
      <Root className={classNames(backgroundType)}>
        <Vertical center gap={0}>
          <DateWrapper>
            <LabelL bold>
              <FormattedDate value={date} day="numeric" month="long" />
            </LabelL>
          </DateWrapper>
          {title}
        </Vertical>
        <DivisionImage src={badgeUrl} alt={divisionTitle} />
        {ctas}
      </Root>
    </Modal>
  );
};
